@if (virtualSports.length) {
    <ds-card-header title="{{ model.title }}" surface="lowest" />
    <div class="body">
        <div class="scrolling-wrapper">
            <ms-scroll-adapter [scrollItems]="virtualSports">
                @for (sport of virtualSports; track $index) {
                    <div class="banner-card-wrapper">
                        <ds-card
                            class="card-alignment"
                            surface="lowest"
                            [elevated]="false"
                            [border]="false"
                            [elevated]="true"
                            (click)="onSportClick(sport)">
                            <img placeholder disableOptimizedSrcset ngSrcset="1x, 2x, 3x" [height]="80" [width]="80" [ngSrc]="sport.imageSrc" />
                        </ds-card>
                    </div>
                }
            </ms-scroll-adapter>
        </div>
    </div>
}
